import { useCallback } from "react";
import { fetchQuery, useQueryLoader, useRelayEnvironment } from "react-relay";
import { WIDGET_CHECKLIST_OVERVIEW_PREVEW_QUERY } from "./WidgetChecklistOverviewPreview";
import { useDebouncedCallback } from "use-debounce";
import { useFocusEffect } from "@react-navigation/native";
import { WidgetChecklistOverviewPreviewQuery } from "./__generated__/WidgetChecklistOverviewPreviewQuery.graphql";

export function useWidgetChecklistOverviewPreviewQuery({
  storecastId,
  teamIds,
  setTeamIds: _setTeamIds,
}: {
  storecastId: string;
  teamIds: string[];
  setTeamIds(_: string[]): void;
}) {
  const [query, loadQuery] =
    useQueryLoader<WidgetChecklistOverviewPreviewQuery>(
      WIDGET_CHECKLIST_OVERVIEW_PREVEW_QUERY
    );

  const environment = useRelayEnvironment();

  const loadPreviewQuery = useDebouncedCallback(
    async (newTeamIds: string[]) => {
      try {
        const variables = {
          storecastId,
          input: {
            teamIds: newTeamIds.length === 0 ? null : newTeamIds,
            size: "TWO_X_FOUR" as const,
          },
        };
        await fetchQuery(
          environment,
          WIDGET_CHECKLIST_OVERVIEW_PREVEW_QUERY,
          variables
        ).toPromise();
        loadQuery(variables, {
          fetchPolicy: "store-and-network",
        });
      } catch {}
    },
    300
  );
  useFocusEffect(
    useCallback(() => {
      loadPreviewQuery(teamIds);
    }, [teamIds, loadPreviewQuery])
  );
  const setTeamIds = useCallback(
    (teamIds: string[]) => {
      _setTeamIds(teamIds);
      loadPreviewQuery(teamIds);
    },
    [_setTeamIds, loadPreviewQuery]
  );
  return [query, setTeamIds] as const;
}
